import { motion } from "framer-motion";
import { Lightbulb, Settings2, LifeBuoy, TrendingUp } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = [Lightbulb, Settings2, LifeBuoy, TrendingUp];
const COLORS = ["#FFE440", "#F15BB5", "#00BBF9", "#00F5D4"];

export const ManifestoProcess = () => {
  const { t } = useLanguage();
  return (
    <section id="process" className="py-20 lg:py-32 bg-white border-y-2 border-black" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-14 max-w-xl"
        >
          <p className="font-['Ubuntu'] text-xs uppercase tracking-[0.25em] font-semibold text-[#9B5DE5] mb-3">{t.process.eyebrow}</p>
          <h2 className="font-['Cutive'] text-2xl sm:text-3xl lg:text-4xl font-bold">{t.process.title}</h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {t.process.steps.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                whileHover={{ y: -6 }}
                className="relative border-2 border-black rounded-2xl p-6 bg-[#FAFAF7]"
                data-testid={`process-step-${i}`}
              >
                <span className="font-['Cutive'] text-5xl text-black/10 absolute top-3 right-4">{step.num}</span>
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center mb-5 border-2 border-black"
                  style={{ backgroundColor: COLORS[i] }}
                >
                  <Icon className="w-6 h-6 text-black" />
                </div>
                <h3 className="font-['Ubuntu'] text-xl font-bold mb-1">{step.title}</h3>
                <p className="font-['Ubuntu'] text-sm text-black/60">{step.desc}</p>
                {i < 3 && (
                  <span className="hidden lg:flex absolute top-1/2 -right-4 -translate-y-1/2 text-2xl">→</span>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
